import { connect } from 'react-redux'
import { IStore } from '../../../../../reducers'
import {
  getLicenses,
  validLicenses,
} from '../../../../../reducers/userAccount/selectors/license'
import AccountMenu from './AccountMenu'
import LanguageMenu from './LanguageMenu'
import { default as Premium, IPremiumMenu } from './PremiumMenu'
import NotificationsMenu from './NotificationsMenu'
import TaskMenu from './TaskMenu'
import ReservationList from './ReservationList'

const mapStateToProps = (state: IStore): IPremiumMenu => ({
  licenses: getLicenses(state),
  validLicenses: validLicenses(state),
})

const PremiumMenu = connect<IPremiumMenu, {}, IPremiumMenu>(mapStateToProps)(
  Premium,
)

export {
  PremiumMenu,
  AccountMenu,
  LanguageMenu,
  NotificationsMenu,
  TaskMenu,
  ReservationList,
}
